(function () {
  'use strict';

  function setStatus(module, message) {
    module.querySelectorAll('[data-chd-installation-status]').forEach(function (status) {
      status.textContent = message || '';
    });
  }

  function update(module, variantId) {
    var dataElement = module.querySelector('[data-chd-installation-data]');
    if (!dataElement) return;

    var facts;
    try {
      facts = JSON.parse(dataElement.textContent || '{}')[String(variantId)] || {};
    } catch (error) {
      return;
    }

    var hasVariantData = false;
    ['cc', 'screw', 'front'].forEach(function (key) {
      var value = facts[key] || '';
      module.querySelectorAll('[data-chd-installation-row="' + key + '"]').forEach(function (row) {
        row.hidden = !value;
      });
      module.querySelectorAll('[data-chd-installation-value="' + key + '"]').forEach(function (output) {
        output.textContent = value;
      });
      if (value) hasVariantData = true;
    });

    module.hidden = !hasVariantData && module.dataset.hasTemplate !== 'true';
  }

  function getCart() {
    return fetch(window.routes.cartUrl + '.js', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not read cart');
      return response.json();
    });
  }

  function addTemplate(variantId) {
    return fetch(window.routes.cartAddUrl + '.js', {
      body: JSON.stringify({ id: variantId, quantity: 1 }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not add template');
      return response.json();
    });
  }

  function markTemplateAdded(module) {
    module.querySelectorAll('[data-chd-installation-template]').forEach(function (input) {
      input.checked = true;
      input.disabled = true;
    });
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('[data-chd-installation-module]').forEach(function (module) {
      update(module, variant && variant.id);
    });
  });

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-chd-installation-open]');
    if (openButton) {
      var sheet = document.getElementById(openButton.getAttribute('aria-controls'));
      if (sheet && typeof sheet.showModal === 'function') {
        sheet._chdInstallationOpener = openButton;
        sheet.showModal();
      }
      return;
    }

    var closeButton = event.target.closest('[data-chd-installation-close]');
    if (closeButton) {
      var dialog = closeButton.closest('dialog');
      if (dialog) dialog.close();
    }
  });

  document.addEventListener('close', function (event) {
    var dialog = event.target;
    if (dialog && dialog.matches && dialog.matches('[data-chd-installation-sheet]') && dialog._chdInstallationOpener) {
      dialog._chdInstallationOpener.focus();
    }
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-chd-installation-template]');
    if (!input) return;

    var module = input.closest('[data-chd-installation-module]');
    var variantId = input.getAttribute('data-variant-id');
    if (!module || !variantId) return;

    if (!input.checked) {
      input.checked = true;
      return;
    }

    if (window.theme && window.theme.cartType === 'page') {
      window.location.href = window.routes.cartAddUrl + '?id=' + encodeURIComponent(variantId) + '&quantity=1';
      return;
    }

    module.querySelectorAll('[data-chd-installation-template]').forEach(function (checkbox) {
      checkbox.disabled = true;
    });
    setStatus(module, '');

    getCart().then(function (cart) {
      var alreadyInCart = cart.items.some(function (item) {
        return String(item.variant_id) === String(variantId);
      });

      if (alreadyInCart) {
        markTemplateAdded(module);
        setStatus(module, input.dataset.alreadyLabel);
        module.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return null;
      }

      return addTemplate(variantId);
    }).then(function (item) {
      if (!item) return;
      markTemplateAdded(module);
      setStatus(module, input.dataset.addedLabel);
      module.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { button: input, variant: item, quantity: 1 }
      }));
    }).catch(function () {
      module.querySelectorAll('[data-chd-installation-template]').forEach(function (checkbox) {
        checkbox.checked = false;
        checkbox.disabled = false;
      });
      setStatus(module, input.dataset.errorLabel);
    });
  });
})();
